import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID || '',
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || '',
  env: process.env.REACT_APP_ENV,
  site: 'datadoghq.com',
  proxyUrl: `${process.env.REACT_APP_BACKEND_URL}/rum/datadog`,
  service: 'uar-chairman',
  version: process.env.REACT_APP_APPLICATION_VERSION || '1.0.0',
  sampleRate: 100,
  sessionReplaySampleRate: 100,
  storeContextsAcrossPages: true,
  trackInteractions: false,
  trackResources: true,
  trackLongTasks: true,
  trackFrustrations: true,
  defaultPrivacyLevel: 'mask',
  useCrossSiteSessionCookie: true,
  allowedTracingOrigins: [
    /https:\/\/.*\.getprodigy\.com/,
    /https:\/\/.*\.upstart\.com/,
  ],
});

datadogRum.startSessionReplayRecording();
